import { createSelector } from 'reselect';
import riskAlertReportModel from "../../models/riskAlertReport";

const riskAlerts = state => state.riskAlerts.list;

const riskAlertsReports = createSelector(
  [riskAlerts],
  (riskAlerts) =>
    riskAlerts
      ? riskAlerts
      : []);

export default {
  riskAlertsReports
}